import { Column, Row } from 'app/design/primitives/box';

import { PlaceholderLine } from 'app/overrides/rn-placeholder/PlaceholderLine';
import { PlaceholderMedia } from 'app/overrides/rn-placeholder/PlaceholderMedia';
import { Shine } from 'app/overrides/rn-placeholder/animations/Shine';
import React from 'react';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export function GreetingSkeleton() {
  return (
    <Shine reverse={false}>
      <Row gap="spacing.general.x3" alignItems="center">
        <PlaceholderMedia style={{ width: 56, height: 56, borderRadius: theme.borderRadii['radius.full'] }} />
        <Column flex={1} gap="spacing.general.x1">
          <PlaceholderLine noMargin height={12} style={{ width: 80, borderRadius: 4 }} />
          <PlaceholderLine noMargin height={22} style={{ width: 160, borderRadius: 4 }} />
          <PlaceholderLine noMargin height={12} style={{ width: 120, borderRadius: 4 }} />
        </Column>
      </Row>
    </Shine>
  );
}
